<template>
  <div>
    <v-card>
      <v-card-title>
        <div class="d-flex justify-space-between" style="width:100%;">
          <h3>Doctors' Calls</h3>
          <div class="d-flex align-center">
            <v-icon @click="clear" class="mr-2">mdi-close</v-icon>
            <v-menu
              ref="menuFrom"
              v-model="menuFrom"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateFrom"
                  label="From"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  style="width:150px"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="pickerFrom"
                v-model="dateFrom"
                :max="new Date().toISOString().substr(0, 10) + 1"
                min="1950-01-01"
              ></v-date-picker>
            </v-menu>

            <v-menu
              ref="menuTo"
              v-model="menuTo"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateTo"
                  label="To"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  class="ml-2"
                  style="width:150px"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="pickerTo"
                v-model="dateTo"
                :max="new Date().toISOString().substr(0, 10) + 1"
                min="1950-01-01"
              ></v-date-picker>
            </v-menu>

            <v-text-field
              class="ml-2"
              v-model="numCalls"
              label="Min Calls"
              style="width:100px;"
              type="number"
            ></v-text-field>
            <v-btn rounded text @click="filter" class="text-capitalize ml-2">
              <p class="mb-0" style="color:rgb(0,170,221)">search</p>
            </v-btn>
          </div>
        </div>
      </v-card-title>
      <v-card-text>
        <v-data-table sort-by="lastCallDate" sort-desc height="400" fixed-header :headers="headers" :items="data" :loading="loading">
           <template v-slot:item.firstName="{item}">
            <span
              style="cursor:pointer; color:rgb(0,170,221)"
              @click="doctorClick(item)"
        
            >{{item.firstName + ' ' + item.lastName}}</span>
          </template>
          <template
              v-slot:item.lastCallDate="{ item }"
            >{{ convertDateWithHour(item.lastCallDate) }}</template>
          <template v-slot:item.verifiedOn="{ item }">{{ convertDate(item.verifiedOn) }}</template>
          <template v-slot:item.validatedOn="{ item }">{{ convertDate(item.validatedOn) }}</template>
          <template v-slot:item.isPublicDoctor="{item}">
            <v-icon>{{ !!item.isPublicDoctor ? 'mdi-check' : '' }}</v-icon>
          </template>
          <template
            v-slot:item.totalTimeOnCallMin=" { item }"
          >{{!!item.totalTimeOnCallMin ? item.totalTimeOnCallMin : '0' }}</template>
          <template
            v-slot:item.acceptedCallCount=" { item }"
          >{{item.acceptedCallCount + ' ('+percentage(item.acceptedCallCount, item.invitedCallCount)+'%)'}}</template>
          <template
            v-slot:item.declinedCallCount=" { item }"
          >{{item.declinedCallCount + ' ('+percentage(item.declinedCallCount, item.invitedCallCount)+'%)'}}</template>
          <template
            v-slot:item.cancelledCallCount=" { item }"
          >{{item.cancelledCallCount + ' ('+percentage(item.cancelledCallCount, item.invitedCallCount)+'%)'}}</template>
          <template
            v-slot:item.timedOutCallCount=" { item }"
          >{{item.timedOutCallCount + ' ('+percentage(item.timedOutCallCount, item.invitedCallCount)+'%)'}}</template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-data-table sort-by="requestedDate" sort-desc height="400" fixed-header :headers="callHeaders" :items="callData">
            
            

            <template
              v-slot:item.requestedDate="{ item }"
            >{{ convertDateWithHour(item.requestedDate) }}</template>
            <template
              v-slot:item.connectedDate="{ item }"
            >{{ convertDateWithHour(item.connectedDate) }}</template>
            <template v-slot:item.endedDate="{ item }">{{ convertDateWithHour(item.endedDate) }}</template>
            <template v-slot:item.durationSec="{ item }">{{ item.durationSec+'s'}}</template>
            <template v-slot:item.endReason="{item}">
              <span :class="getClass(item.endReason)" class="white--text pa-1">{{item.endReason}}</span>
            </template>

          
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
export default {
  created() {
    this.loading = true;
    axios
      .get(`${process.env.VUE_APP_BASE_URL}admin/doctorsWithVideoCalls/list`)
      .then(res => {
        console.log(res);
        this.loading = false;
        this.data = res.data.results;
        this.count = res.data.totalCount;
      })
      .catch(err => {
        this.loading = false;
        console.log(err);
      });
  },

  data() {
    return {
      dialog: false,
      headers: [
        {
          text: "Name",
          value: "firstName"
        },
        {
          text: 'Last call',
          value: 'lastCallDate'
        },
        {
          text: "Verified",
          value: "verifiedOn"
        },
        {
          text: "Validated",
          value: "validatedOn"
        },
        {
          text: "Doctor Type",
          value: "doctorTypeName"
        },
        {
          text: "Municipality",
          value: "currentMunicipalityName"
        },
        {
          text: "Prefecture",
          value: "currentPrefectureName"
        },
        {
          text: "Public Doctor",
          value: "isPublicDoctor"
        },
        {
          text: "Total minutes",
          value: "totalTimeOnCallMin"
        },
        {
          text: "Times Invited",
          value: "invitedCallCount"
        },
        {
          text: "Calls Accepted",
          value: "acceptedCallCount"
        },
        {
          text: "Calls Declined",
          value: "declinedCallCount"
        },
        {
          text: "Calls got Cancelled",
          value: "cancelledCallCount"
        },
        {
          text: "Calls Timeout",
          value: "timedOutCallCount"
        },
        {
          text: "Urgent calls",
          value: "urgentCallCount"
        },
        {
          text: "Usefull calls",
          value: "usefulCallCount"
        },
        {
          text: "Useless calls",
          value: "uselessCallCount"
        },
        {
          text: "Interrupted calls",
          value: "noRatingCallCount"
        },
        {
          text: "Unrated calls",
          value: "nullRatingCallCount"
        }
      ],
      menuFrom: false,
      menuTo: false,
      data: [],
      loading: false,
      count: 0,
      dateFrom: "",
      dateTo: "",
      numCalls: "",

       callHeaders: [
        {
          text: "Patient first name",
          value: "travellerFirstName"
        },
        {
          text: "Patient last name",
          value: "travellerLastName"
        },
        {
          text: "Patient email",
          value: "travellerEmail"
        },
        {
          text: 'Patient municipality',
          value: 'travellerMunicipality'
        },
        {
          text: "Requested at",
          value: "requestedDate"
        },
        {
          text: "Connected at",
          value: "connectedDate"
        },
        {
          text: "Ended at",
          value: "endedDate"
        },
        {
          text: "Reason",
          value: "endReason"
        },
        {
          text: "Duration",
          value: "durationSec"
        },
        {
          text: "Rating",
          value: "doctorsRating"
        }
      ],
      callData: null
    };
  },
  methods: {
    doctorClick(doctor){
      this.loading = true
      axios.get(`${process.env.VUE_APP_BASE_URL}admin/videoCalls/list?doctorId=${doctor.doctorId}`)
      .then(res => {
        console.log(res)
        this.loading=false
        this.callData = res.data.results
        this.dialog = true
      })
      .catch(err => {
        this.loading=false
        console.log(err)
      })
    },
    getClass(endReason) {
      if (endReason === "cancelledByCaller") return "orange";
      else if (endReason === "declinedByReceiver") return "red";
      else if (endReason === "patient") return "green";
      else if (endReason === "doctor") return "green";
      else return "gray";
    },
    convertDate(date) {
      
      return moment(moment.utc(date).toDate())
        .local()
        .format("DD/MM");
    },
    convertDateWithHour(date) {
      if (!!!date) return "";
      return moment(moment.utc(date).toDate())
        .local()
        .format("DD/MM HH:mm:ss");
    },
    percentage(num, per) {
      return Math.floor((num / per) * 100);
    },
    filter() {
      this.loading = true;
      axios
        .get(
          `${process.env.VUE_APP_BASE_URL}admin/doctorsWithVideoCalls/list?${
            this.dateFrom === "" ? "" : "dateFrom=" + this.dateFrom
          }${this.dateTo === "" ? "" : "&dateTo=" + this.dateTo}${
            this.numCalls === "" ? "" : "&numCalls=" + this.numCalls
          } `
        )
        .then(res => {
          console.log(res);
          this.loading = false;
          this.data = res.data.results;
          this.count = res.data.totalCount;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    clear() {
      this.dateFrom = "";
      this.dateTo = "";
      (this.numCalls = ""), this.filter();
    }
  },
  watch: {
    menuFrom(val) {
      val && setTimeout(() => (this.$refs.pickerFrom.activePicker = "YEAR"));
    },
    menuTo(val) {
      val && setTimeout(() => (this.$refs.pickerTo.activePicker = "YEAR"));
    }
  }
};
</script>

<style scoped>
.orange {
  background-color: orange;
  border-radius:5px;
}

.green {
  background-color: green;
  border-radius:5px;
}

.red{
  background-color:red;
  border-radius: 5px;
}

.gray {
  background-color: gray;
  border-radius:5px;
}
</style>